const DELIVERY_STATUS_COLORS: Record<string, string> = {
  'enviado': 'green',
  'entregue': 'green',
  'aguardando envio': 'blue',
  'pendente': 'blue',
  'em separacao': 'gold',
  'cancelado': 'red',
  'cancelada': 'red',
  'devolvido': 'red',
  'devolvida': 'red',
  'extraviado': 'red'
};

const normalizeStatus = (status: string) =>
  status
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

export const getDeliveryStatusColor = (status: string): string | undefined =>
  DELIVERY_STATUS_COLORS[normalizeStatus(status)];
